"use client"

import { Shield } from "lucide-react"

import { TrustBadges } from "@shared/ui/landing/trust-badges"

import { useTranslations } from "@/lib/i18n/client"

export function SiteFooter() {
  const t = useTranslations("footer")
  const tCommon = useTranslations("common")
  const tTrust = useTranslations("trust")

  const columns = [
    {
      title: t("product"),
      links: [
        { href: "#score", label: t("securityScore") },
        { href: "#detection", label: t("detection") },
        { href: "#report", label: t("reports") },
      ],
    },
    {
      title: t("resources"),
      links: [
        { href: "#knowledge", label: t("knowledgeBase") },
        { href: "#threats", label: t("threatCenter") },
        { href: "#network", label: t("globalNetwork") },
      ],
    },
  ]

  return (
    <footer className="border-t border-white/5 bg-black/40">
      <div className="mx-auto max-w-6xl px-4 py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex size-8 items-center justify-center rounded-lg bg-sky-500/10 ring-1 ring-sky-500/30">
                <Shield className="size-4 text-sky-400" />
              </span>
              <span className="font-semibold">{tCommon("appName")}</span>
            </div>
            <p className="text-sm text-muted-foreground">{t("tagline")}</p>
            <TrustBadges
              labels={{
                verified: tTrust("verified"),
                ssl: tTrust("ssl"),
                encryption: tTrust("encryption"),
              }}
            />
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="mb-4 text-sm font-semibold">{column.title}</h3>
              <ul className="space-y-2">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            {t("copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  )
}
